export default __webpack_public_path__ + "static/media/ic_status_pause.1f5ca7f5.svg";